var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOthersChannelImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_41169",
    "data-name": "Group 41169",
    transform: "translate(-1186 -5226)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6025",
    "data-name": "Ellipse 6025",
    cx: 7.5,
    cy: 7.5,
    r: 7.5,
    transform: "translate(1186 5226)",
    fill: "#678bff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6026",
    "data-name": "Ellipse 6026",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1192 5232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6027",
    "data-name": "Ellipse 6027",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1188 5232)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6028",
    "data-name": "Ellipse 6028",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1196 5232)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOthersChannelImage);
export default __webpack_public_path__ + "static/media/others_channel_image.de68dd68fd1b97f30ac545ec28092076.svg";
export { ForwardRef as ReactComponent };